import Vue from 'vue'
import {get,post,put} from './axios'

//get方法
export const getcase = () => get('/5cc14c156ed55a28ad573203/rightrlist/rightlist');
//post方法
export const  postcase =(id)=>post('/5cc14c156ed55a28ad573203/rightrlist/rightlist',{id:id});
//put方法
export const  putcase =(id)=>put('/5cc14c156ed55a28ad573203/rightrlist/rightlist',{id:id});
//delete方法
//export const  deletecase =(id)=>Delete('/5cc14c156ed55a28ad573203/rightrlist/rightlist',{data:{id:id}});







//-----------------------我的-------------------------



//获取主分类
export const getmainclass= (page,pageSize) => post('/getmainclass',{page,pageSize});

//根据子类获取应用列表
export const getsubclassselectos = (subclassid) => post('/subclassselectos',{subclassid});


//根据ID获取应用详情
export const getappdetail = (id,page=1,pageSize=1) => post('/serachos',{id,page,pageSize});


//根据主类获取顶部热门推荐
export const getselectmainhotpick = (mainclassid) => post('/selectmainhotpick',{mainclassid});




// //获取分类（按字母排序）
// export const getcategorylist = () => get('/v1/category/list');

// //通过id获取页面数据
// export const getlistByCategory = (categoryId) => post('/v1/website/listByCategory',{categoryId:categoryId});

// //通过字母获取页面数据
// export const getlistByCategoryInitial = (initial) => post('/v1/website/listByCategoryInitial',{initial:initial});

// //职业/标签列表首页左边
// export const getlistSimple = () => post('/v1/tag/listSimple');

// //职业/标签列表首页右边分类
// export const gettaglist = () => post('/v1/tag/list');





// WEBPACK FOOTER //
// ./src/api/api.js